import React, { memo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../../../../contexts/LanguageContext';
import { useClientSideSort } from '../../../../hooks/useClientSideSort';

const formatDate = (date) => (!date ? '-' : new Date(date).toLocaleDateString('tr-TR'));

const ChassisDetailPartListTable = ({ rows = [], loading = false, failureDate, repairKm }) => {
  const { th } = useLanguage();
  const { sortedData, sortField, sortOrder, onSort } = useClientSideSort(rows);

  return (
    <DataTable
      value={sortedData}
      className="p-datatable-gridlines"
      showGridlines
      paginator
      rows={5}
      onSort={onSort}
      sortField={sortField}
      sortOrder={sortOrder}
      dataKey="id"
      loading={loading}
      emptyMessage={th('warrantyClaims.detail.partTable.noRecordsFound')}
      rowsPerPageOptions={[5, 10, 25, 50]}
      tableStyle={{ minWidth: '40rem' }}
    >
      <Column field="itemCode" header={th('warrantyClaims.detail.partTable.partCode')} sortable />
      <Column field="itemCodeDesc" header={th('warrantyClaims.detail.partTable.partDescription')} sortable />
      <Column field="quantity" header={th('warrantyClaims.detail.partTable.quantity')} sortable />
      <Column field="repairKm" header={th('warrantyClaims.table.repairKm')} body={() => repairKm ?? '-'} />
      <Column field="repairDate" header={th('warrantyClaims.detail.form.repairDate')} body={() => formatDate(failureDate)} />
    </DataTable>
  );
};

export default memo(ChassisDetailPartListTable);